import React, {
  useContext,
  useEffect,
  useState,
} from "react";

import { TranslatorContext } from "../../../context/Translator";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Form,
  Button,
} from "react-bootstrap";

import PageLayout from "../../../layouts/PageLayout";

import axios from "axios";
import MedicalTableComponent from "../../../components/tables/MedicalTableComponent";

export default function MedicalCare() {
  const { t } = useContext(TranslatorContext);

  const [medicalCare, setMedicalCare] = useState([]);
  const [allMedicalCare, setAllMedicalCare] = useState([]);

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] =
    useState("");
  const [hospitalFilter, setHospitalFilter] =
    useState("");
  const [doctorFilter, setDoctorFilter] =
    useState("");

  const AuthToken =
    localStorage.getItem("AuthUser");

  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${AuthToken}`;

  /*
  |--------------------------------------------------------------------------
  | Fetch Medical Care
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    fetchMedicalCare();
  }, []);

  const fetchMedicalCare = async () => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_URL +
        "/medical-care"
      );

      const mappedData = (res.data.data || []).map((medical) => ({
        id: medical.id,

        f_number: medical.f_number || "",

        person_name: medical.person_name || "",

        relation: medical.relation || "",
        date_of_treatment: medical.date_of_treatment || "",

        doctor_name: medical.doctor_name || "",

        hospital_name: medical.hospital_name || "",

        medicine_amount: Number(medical.medicine_amount || 0),

        doctor_fee: Number(medical.doctor_fee || 0),

        total_amount:
          medical.total_amount !== null &&
            medical.total_amount !== undefined
            ? Number(medical.total_amount)
            : Number(medical.medicine_amount || 0) +
            Number(medical.doctor_fee || 0),

        medical_reason: medical.medical_reason || "",
        treatment_way: medical.treatment_way || "",

        status: medical.status || "Pending",

        action: {
          edit: "edit",
          delete: "delete",
        },
      }));
      setMedicalCare(mappedData);
      setAllMedicalCare(mappedData);
    } catch (error) {
      console.error(
        "Medical Care Error:",
        error
      );
    }
  };

  /*
  |--------------------------------------------------------------------------
  | Filter Medical Care
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    let filtered = [
      ...allMedicalCare,
    ];

    /*
    |--------------------------------------------------------------------------
    | Search
    |--------------------------------------------------------------------------
    */

    if (search) {
      const searchValue =
        search.toLowerCase();

      filtered = filtered.filter(
        (item) =>
          item.f_number
            ?.toLowerCase()
            .includes(searchValue) ||

          item.person_name
            ?.toLowerCase()
            .includes(searchValue) ||

          item.doctor_name
            ?.toLowerCase()
            .includes(searchValue) ||

          item.hospital_name
            ?.toLowerCase()
            .includes(searchValue)
      );
    }

    /*
    |--------------------------------------------------------------------------
    | Status Filter
    |--------------------------------------------------------------------------
    */

    if (statusFilter !== "") {
      filtered = filtered.filter(
        (item) =>
          String(item.status) ===
          String(statusFilter)
      );
    }

    /*
    |--------------------------------------------------------------------------
    | Hospital Filter
    |--------------------------------------------------------------------------
    */

    if (hospitalFilter) {
      filtered = filtered.filter(
        (item) =>
          item.hospital_name ===
          hospitalFilter
      );
    }

    /*
    |--------------------------------------------------------------------------
    | Doctor Filter
    |--------------------------------------------------------------------------
    */

    if (doctorFilter) {
      filtered = filtered.filter(
        (item) =>
          item.doctor_name ===
          doctorFilter
      );
    }

    setMedicalCare(filtered);
  }, [
    search,
    statusFilter,
    hospitalFilter,
    doctorFilter,
    allMedicalCare,
  ]);

  /*
  |--------------------------------------------------------------------------
  | Hospitals
  |--------------------------------------------------------------------------
  */

  const hospitals = [
    ...new Set(
      allMedicalCare
        .map(
          (item) =>
            item.hospital_name
        )
        .filter(Boolean)
    ),
  ];

  /*
  |--------------------------------------------------------------------------
  | Doctors
  |--------------------------------------------------------------------------
  */

  const doctors = [
    ...new Set(
      allMedicalCare
        .map(
          (item) =>
            item.doctor_name
        )
        .filter(Boolean)
    ),
  ];

  /*
  |--------------------------------------------------------------------------
  | Statuses
  |--------------------------------------------------------------------------
  */

  const statuses = [
    ...new Set(
      allMedicalCare
        .map(
          (item) => item.status
        )
        .filter(Boolean)
    ),
  ];

  /*
  |--------------------------------------------------------------------------
  | Reset Filters
  |--------------------------------------------------------------------------
  */

  const resetFilters = () => {
    setSearch("");
    setStatusFilter("");
    setHospitalFilter("");
    setDoctorFilter("");
  };

  /*
  |--------------------------------------------------------------------------
  | Render
  |--------------------------------------------------------------------------
  */

  return (
    <PageLayout>
      <Row>

        {/* ==========================================================
            BREADCRUMB
        ========================================================== */}

        <Col xl={12}>
          <div className="mc-card">

            <div className="mc-breadcrumb">

              <h3 className="mc-breadcrumb-title">
                Medical Care (
                {medicalCare.length}
                )
              </h3>

              <ul className="mc-breadcrumb-list">

                <li className="mc-breadcrumb-item">
                  <Link
                    to="#"
                    className="mc-breadcrumb-link"
                  >
                    {t("home")}
                  </Link>
                </li>

                <li className="mc-breadcrumb-item">

                  <Link
                    to="#"
                    className="mc-breadcrumb-link"
                  >
                    Medical Care
                  </Link>

                </li>

                <li className="mc-breadcrumb-item">
                  All Medical Care List
                </li>

              </ul>

            </div>

          </div>
        </Col>

        {/* ==========================================================
            MAIN CARD
        ========================================================== */}

        <Col xl={12}>
          <div className="mc-card">

            {/* ======================================================
                FILTERS
            ====================================================== */}

            <Row className="mb-4 g-2">

              {/* Search */}

              <Col md={3}>

                <Form.Control
                  type="text"
                  placeholder="Search Family / Person / Doctor"
                  value={search}
                  onChange={(e) =>
                    setSearch(
                      e.target.value
                    )
                  }
                />

              </Col>

              {/* Status */}

              <Col md={2}>

                <Form.Select
                  value={statusFilter}
                  onChange={(e) =>
                    setStatusFilter(
                      e.target.value
                    )
                  }
                >

                  <option value="">
                    All Status
                  </option>

                  {statuses.map(
                    (
                      status,
                      index
                    ) => (
                      <option
                        key={index}
                        value={status}
                      >
                        {status}
                      </option>
                    )
                  )}

                </Form.Select>

              </Col>

              {/* Hospital */}

              <Col md={3}>

                <Form.Select
                  value={
                    hospitalFilter
                  }
                  onChange={(e) =>
                    setHospitalFilter(
                      e.target.value
                    )
                  }
                >

                  <option value="">
                    All Hospitals
                  </option>

                  {hospitals.map(
                    (
                      hospital,
                      index
                    ) => (
                      <option
                        key={index}
                        value={hospital}
                      >
                        {hospital}
                      </option>
                    )
                  )}

                </Form.Select>

              </Col>

              {/* Doctor */}

              <Col md={3}>

                <Form.Select
                  value={doctorFilter}
                  onChange={(e) =>
                    setDoctorFilter(
                      e.target.value
                    )
                  }
                >

                  <option value="">
                    All Doctors
                  </option>

                  {doctors.map(
                    (
                      doctor,
                      index
                    ) => (
                      <option
                        key={index}
                        value={doctor}
                      >
                        {doctor}
                      </option>
                    )
                  )}

                </Form.Select>

              </Col>

              {/* Reset */}

              <Col md={1}>

                <Button
                  variant="secondary"
                  onClick={
                    resetFilters
                  }
                  className="w-100"
                >
                  Reset
                </Button>

              </Col>

            </Row>

            {/* ======================================================
                TABLE
            ====================================================== */}

            <Row>

              <Col xl={12}>

                <MedicalTableComponent
                  thead={[
                    "Family",
                    "Person's Name",
                    "Relation",
                    'Date of Treatment',
                    'Treatment Way',
                    "Doctor's Name",
                    "Hospital's Name",
                    "Medicine Amount",
                    "Doctor Fee",
                    "Total Amount",
                    "Medical Reason",
                    // "Status",
                    "Actions",
                  ]}
                  tbody={medicalCare}
                />

              </Col>

            </Row>

          </div>
        </Col>

      </Row>
    </PageLayout>
  );
}